import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Radio } from "antd";
import { loggedInUserSelector } from "../../../../store/slice/auth";
import { isUserDivisional } from "../../../../swzutils/UserPermissionsUtil";
import DivisionSelect from "./DivisionSelect";
import { useAppSelector } from "../../../../store";
var DivisionAccessType;
(function (DivisionAccessType) {
    DivisionAccessType["ALL"] = "ALL";
    DivisionAccessType["RESTRICTED"] = "RESTRICTED";
})(DivisionAccessType || (DivisionAccessType = {}));
const DivisionAccessFormFields = ({ tenantId, disabled = false, allowMultiple = false, canBeRestricted = true, value, onChange }) => {
    const [divisionAccessType, setDivisionAccessType] = useState(DivisionAccessType.ALL);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    useEffect(() => {
        setDivisionAccessType(value ? DivisionAccessType.RESTRICTED : DivisionAccessType.ALL);
    }, [value]);
    const onDivisionAccessChanged = (e) => {
        const divisionAccessType = e.target.value;
        setDivisionAccessType(divisionAccessType);
        onChange && onChange(undefined);
    };
    return (_jsxs("div", { children: [!isUserDivisional(loggedInUser) && canBeRestricted &&
                _jsxs("div", { children: [_jsxs(Radio.Group, { buttonStyle: "solid", value: divisionAccessType, onChange: onDivisionAccessChanged, children: [_jsx(Radio.Button, { value: DivisionAccessType.ALL, children: "All" }), _jsx(Radio.Button, { value: DivisionAccessType.RESTRICTED, children: "Only Listed" })] }), _jsx("div", { children: "\u00A0" })] }), _jsx(DivisionSelect, { allowMultiple: allowMultiple, value: value, disabled: (canBeRestricted && divisionAccessType !== DivisionAccessType.RESTRICTED) || disabled, onChange: onChange, tenantId: tenantId })] }));
};
export default DivisionAccessFormFields;
